import React from 'react';
import { CheckCircle } from '@mui/icons-material';
import { Header } from '../components/Header/Header';
import './SuccessPage.scss';

export function SuccessPage() {
  return (
    <div className="success-page">
      <Header />
      <div className="success-page__content">
        <div className="success-page__icon">
          <CheckCircle sx={{ fontSize: 64, color: '#198754' }} />
        </div>
        <h2 className="success-page__title">Signature Submitted</h2>
        <p className="success-page__message">
          Your signature has been successfully submitted. Your healthcare
          provider has been notified.
        </p>
        <p className="success-page__note">
          You can safely close this page.
        </p>
      </div>
    </div>
  );
}

export default SuccessPage;
